import { render, staticRenderFns } from "./square_detial.vue?vue&type=template&id=765a28ea&scoped=true"
import script from "./square_detial.vue?vue&type=script&lang=js"
export * from "./square_detial.vue?vue&type=script&lang=js"
import style0 from "./square_detial.vue?vue&type=style&index=0&id=765a28ea&prod&scoped=true&lang=less"
import style1 from "./square_detial.vue?vue&type=style&index=1&id=765a28ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a28ea",
  null
  
)

export default component.exports